import { PlayerStore } from "@/features/player/model/store";
import React from "react";

export const PlayerStoreContext = React.createContext<PlayerStore | null>(null);

export const PlayerStoreProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const store = React.useRef(new PlayerStore()).current;
    return (
        <PlayerStoreContext.Provider value={store}>
            {children}
        </PlayerStoreContext.Provider>
    );
};
